import React from 'react';

import Company from './Company';
import Hero from './Hero';
import Steps from './Steps';

const Home = () => {
    return (
        <div>
            <Hero></Hero>
            <Company></Company>
            <Steps></Steps>
        </div>
    );
};

export default Home;